export enum RegistrationType {
    Invitation,
    SelfRegistrationWithoutOrganisation,
    SelfRegistrationWithOrganisation
}
